import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-new-trangle",
  "use": "icon-seq-new-trangle-usage",
  "viewBox": "0 0 5 13",
  "content": "<symbol viewBox=\"0 0 5 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-new-trangle\">\n<path d=\"M4.23223 5.40898C4.59082 5.79347 4.77012 5.98572 4.83786 6.20452C4.8975 6.39717 4.8975 6.60335 4.83786 6.79599C4.77012 7.0148 4.59082 7.20705 4.23223 7.59154L-1.52801e-08 12.1294L4.76837e-07 0.871094L4.23223 5.40898Z\" fill=\"#E1E2E6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol